import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './AuthCard.module.scss';

/**
 * `notice` is the centered mascot layout (confirmation and blocking screens),
 * `form` is the plain card the sign-in and code forms sit in.
 */
type AuthCardVariant = 'form' | 'notice';

type AuthCardProps = {
  children: ReactNode;
  className?: string;
  cardClassName?: string;
  variant?: AuthCardVariant;
  dataSection?: string;
  /** Set when the card is portalled over a page rather than being the page. */
  fixed?: boolean;
};

export const AuthCard: FC<AuthCardProps> = (props) => {
  const {
    children,
    className,
    cardClassName,
    variant = 'form',
    dataSection,
    fixed,
  } = props;

  return (
    <div
      className={cn(styles.overlay, fixed && styles.fixed, className)}
      data-section={dataSection}
    >
      <div
        className={cn(
          styles.card,
          variant === 'notice' && styles.notice,
          cardClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
